var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubstitution(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M9.282 20.866l2.498 2.497a.402.402 0 0 1-.004.569.402.402 0 0 1-.568.003l-3.18-3.18a.402.402 0 0 1 .003-.568l3.22-3.22a.402.402 0 0 1 .568-.003.402.402 0 0 1-.003.569L9.287 20.06l14.323-.092c.364-.002.545.136.544.413-.003.416-.327.39-.55.391l-14.322.093zm13.45-9.717L20.234 8.65a.402.402 0 0 1 .004-.569.402.402 0 0 1 .569-.003l3.18 3.18a.402.402 0 0 1-.004.568l-3.22 3.22a.402.402 0 0 1-.568.003.402.402 0 0 1 .003-.568l2.529-2.529-14.365.089c-.365.001-.546-.137-.544-.414.001-.277.184-.408.549-.39l14.365-.09z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstitution);
export default __webpack_public_path__ + "static/media/substitution.7dad85cf13afcfab785176eea4da3e75.svg";
export { ForwardRef as ReactComponent };